// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { z } from 'zod';

export const signatureSchema = z
  .object({
    acceptedAccountTerms: z.boolean('Account terms must be accepted'),
    acceptedDataProtection: z.boolean('Data protection must be accepted'),
    confirmedInformationTruthfulness: z.boolean(
      'Truthfulness confirmation is required',
    ),
  })
  .check(({ value, issues }) => {
    const data = value;

    if (!data.acceptedAccountTerms) {
      issues.push({
        code: 'custom',
        input: data.acceptedAccountTerms,
        path: ['acceptedAccountTerms'],
      });
    }
    if (!data.acceptedDataProtection) {
      issues.push({
        code: 'custom',
        input: data.acceptedDataProtection,
        path: ['acceptedDataProtection'],
      });
    }

    if (!data.confirmedInformationTruthfulness) {
      issues.push({
        code: 'custom',
        input: data.confirmedInformationTruthfulness,
        path: ['confirmedInformationTruthfulness'],
      });
    }
  });

export type SignatureFormData = z.infer<typeof signatureSchema>;
